module.exports = __webpack_public_path__ + "static/media/currency.a255c3a1.svg";